import { render, staticRenderFns } from "./hdyx.vue?vue&type=template&id=8b2503e6&scoped=true&"
import script from "./hdyx.vue?vue&type=script&lang=js&"
export * from "./hdyx.vue?vue&type=script&lang=js&"
import style0 from "./hdyx.vue?vue&type=style&index=0&id=8b2503e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2503e6",
  null
  
)

export default component.exports